module.exports = __webpack_public_path__ + "static/media/DAB.d488b260.png";